import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";

import { login } from "app/api/busha";
import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";

export default function useLogin() {
  const { isLoading, data, mutate } = useMutation(login, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      console.log(error);

      toast.error(errorMessage);
    },
  });

  return { isLoading, data: data?.data, login: mutate };
}
